// extracted by mini-css-extract-plugin
module.exports = {"launch_app":"style_launch_app__19Y5q","launch_app_img":"style_launch_app_img__1lGPt"};